<script setup lang="ts">
import { computed } from 'vue';
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue']);
const props = defineProps<{
  title?: string,
  maxlength?: {
    hours: number,
    minutes: number
  },
  windowInnerWidth: number,
  modelValue: {
    hours: number | null,
    minutes: number | null
  },
  errors: {
    hours: string[],
    minutes: string[]
  }
}>();


const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

</script>
<template>
  <v-col cols="1">
    <div class="pl-3" style="font-size: 14px">{{ props.title }}</div>
  </v-col>
  <v-col
    :cols="windowInnerWidth > 800 ? 3 : 5"
    :style="windowInnerWidth > 800 ? '' : 'margin-right: 23px;'"
  >
    <v-text-field
      v-model="modelValue.hours"
      :suffix="i18n.global.t('pages.operationOffices.hours')"
      class="mt-0"
      density="compact"
      :min="0"
      :maxlength="props.maxlength?.hours"
      :error-messages="errors?.hours"
    />
  </v-col>
  <v-col :cols="windowInnerWidth > 800 ? 3 : 5">
    <v-text-field
      v-model="modelValue.minutes"
      :suffix="i18n.global.t('pages.operationOffices.minutes')"
      class="mt-0"
      density="compact"
      :min="0"
      :maxlength="props.maxlength?.minutes"
      :error-messages="errors?.minutes"
    />
  </v-col>
</template>
